import { type ICollectionDetails } from "~/hooks/useCollections"
import { type IVariantSummary } from "~/hooks/useVariantTableData"
import { type PresetView, useActivePreset } from "~/components/planning/presetView"
import { COLLECTIONS_CUSTOMERS_TABLE_ID, COLLECTIONS_PERFORMANCE_TABLE_ID } from "~/constants"
import CollectionCustomersTab from "~/components/collections/tabs/CollectionCustomersTab"
import CollectionProductsTab from "~/components/collections/tabs/CollectionProductsTab"

type AnalysisPresetMeta = { kind: "customers" | "performance" }

export const ANALYSIS_PRESET_GROUP_ID = "analysis-collection"

const ANALYSIS_PRESETS: PresetView<AnalysisPresetMeta>[] = [
  {
    id: "customers",
    name: "Customers",
    tableId: COLLECTIONS_CUSTOMERS_TABLE_ID,
    meta: { kind: "customers" },
  },
  {
    id: "performance",
    name: "Product Performance",
    tableId: COLLECTIONS_PERFORMANCE_TABLE_ID,
    meta: { kind: "performance" },
  },
]

type Props = {
  collections: ICollectionDetails[]
  variants: IVariantSummary[]
  startDate: Date
  endDate: Date
}

const CollectionAnalysisTab = (props: Props) => {
  const { activePreset } = useActivePreset(ANALYSIS_PRESET_GROUP_ID, ANALYSIS_PRESETS)

  if (activePreset?.meta?.kind === "performance") {
    return (
      <CollectionProductsTab
        {...props}
        presetViews={ANALYSIS_PRESETS}
        presetGroupId={ANALYSIS_PRESET_GROUP_ID}
      />
    )
  }

  return (
    <CollectionCustomersTab
      {...props}
      presetViews={ANALYSIS_PRESETS}
      presetGroupId={ANALYSIS_PRESET_GROUP_ID}
    />
  )
}

export default CollectionAnalysisTab
